import React from 'react';

    function AdComponent() {
      return (
        <div>
          <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-2736401220449917"
            data-ad-slot="8825654220"
            data-ad-format="auto"
          ></ins>
        </div>
      );
    }
    
export default AdComponent;
